import { render, staticRenderFns } from "./canva_cta_pre.vue?vue&type=template&id=3f87e05c&scoped=true&"
import script from "./canva_cta_pre.vue?vue&type=script&lang=js&"
export * from "./canva_cta_pre.vue?vue&type=script&lang=js&"
import style0 from "./canva_cta_pre.vue?vue&type=style&index=0&id=3f87e05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f87e05c",
  null
  
)

export default component.exports